import { render, staticRenderFns } from "./MapboxWrapper.vue?vue&type=template&id=5afedefb&scoped=true&"
import script from "./MapboxWrapper.vue?vue&type=script&lang=js&"
export * from "./MapboxWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MapboxWrapper.vue?vue&type=style&index=0&id=5afedefb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afedefb",
  null
  
)

export default component.exports